import { render, staticRenderFns } from "./PrintBangTheoDoiCoc.vue?vue&type=template&id=57deedd5"
import script from "./PrintBangTheoDoiCoc.vue?vue&type=script&lang=js"
export * from "./PrintBangTheoDoiCoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports